import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../utils/axiosInstance";
import "../styles/RegisterPage.css";

export default function RenewSubscriptionPage() {
  const { t } = useTranslation("common");
  const [email, setEmail] = useState(localStorage.getItem("renewEmail") || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const startRenewPayment = async () => {
    setError("");
    setLoading(true);

    try {
        const createRes = await axiosInstance.post("/api/payment/orders/renew/create/", {
          email,
        });

      const orderId = createRes.data.order_id;

      const startRes = await axiosInstance.post(
       `/api/payment/orders/renew/${orderId}/start/`,
       { email }
      );

      window.location.href = startRes.data.payment_url;
    } catch (err) {
      setError(err?.response?.data?.detail || t("renew.paymentFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container ta dental">
      <div className="auth-box ta dental renew-box" style={{ maxWidth: 520 }}>
        <h2 className="auth-title ta dental">{t("renew.title")}</h2>

        <div
          className="position-alert ta dental"
          style={{
            background: "#fff7ed",
            border: "1px solid #fed7aa",
            color: "#9a3412",
            textAlign: "center",
          }}
        >
          <b>{t("renew.expiredNoticeBold")}</b>
          <br />
          {t("renew.expiredNoticeText")}
        </div>

        <div
          className="position-alert ta dental"
          style={{
            background: "#f8fafc",
            border: "1px dashed #cbd5e1",
            color: "#0f172a",
            textAlign: "center",
          }}
        >
          <b>{t("renew.paymentRequiredBold")}</b>
          <br />
            {t("renew.feeLabel")} <b>{t("renew.feeAmount")}</b>
        </div>

        <p style={{ fontSize: 12, color: "#64748b", textAlign: "center" }}>
          {t("renew.secureNote")}
        </p>

        <form
          className="auth-form ta dental"
          onSubmit={(e) => {
            e.preventDefault();
            startRenewPayment();
          }}
        >
          <label className="ta dental">{t("renew.emailLabel")}</label>
          <input
            className="ta dental"
            type="email"
            value={email}
            placeholder={t("renew.emailPlaceholder")}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          {error && <div className="position-alert ta dental">{error}</div>}

          <button
            type="submit"
            className="auth-button ta dental"
            disabled={loading || !email}
          >
            {loading ? t("renew.submitting") : t("renew.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
